import { SignInRoute } from '../signIn/routes';

export const ErrorRoute = {
  NOT_FOUND: 'not-found',
  ACCESS_DENIED: '/access-denied',
  UNAUTHORIZED: SignInRoute.SIGN_IN,
  INTERNAL: '/'
}